<template>
	<div class="page">
		<navbar />
		<breadcrumb :list="breadcrumbList" />
		<div class="content flex-direction-column" v-if="modelList.length">
			<div class="mess flex-space-between">
				<div class="swiper">
					<el-carousel ref="carousel" trigger="click" height="300px" :interval="5000" @change="(index) => (activeIndex = index)">
						<el-carousel-item v-for="(item, index) in getCarousel()" :key="index">
							<img style="width: 100%; height: 100%; object-fit: contain" :src="item" alt="" />
						</el-carousel-item>
					</el-carousel>
					<div class="indicator">
						<div class="indicator-item" :class="{ 'indicator-active': index === activeIndex }" v-for="(item, index) in getCarousel()" :key="index" @click="handleIndicatorClick(index)">
							<img :src="item" alt="" />
						</div>
					</div>
				</div>
				<div class="info flex-direction-column">
					<div class="title">
						{{ modelList[0].standardname }}
						<div class="flex subtitle">
							<div class="label">アイシン品番：</div>
							<div class="value">
								{{ $route.query.value.toLocaleUpperCase().replace(/-/g, "") }}
							</div>
						</div>
						<div class="flex subtitle">
							<div class="label">純正品番：</div>
							<div class="flex-direction-column">
								<div class="value" style="margin-bottom: 5px" v-for="(item, index) in modelList[0].oes" :key="index">
									{{ item.join("，") }}
								</div>
							</div>
						</div>
					</div>

					<!-- <div class="table flex-wrap" v-for="item in modelList" :key="item.goods_bianhao">
						<div class="table-item flex">
							<div class="table-item-name">純正品番</div>
							<div class="table-item-value">
								<span v-for="ii in item.oes" :key="ii">{{ ii }}</span>
							</div>
						</div>
						<div class="table-item flex">
							<div class="table-item-name">纯正品名</div>
							<div class="table-item-value">{{ item.replace_oe && item.replace_oe.length ? item.replace_oe[0].brand_name : "-" }}</div>
						</div>
					</div> -->
				</div>
			</div>
			<span style="margin-top: 15px">Result： {{ tableData.length }}</span>
			<div class="table" style="margin-top: 20px">
				<el-table v-loading="loading" ref="multipleTable" tooltip-effect="dark" :data="tableData" :header-cell-style="{ background: '#F7F7F7', color: '#000000' }" style="width: 100%">
					<el-table-column align="center" prop="brand" label="BRAND" key="brand">
						<template #header>
							<div class="custom-header">
								BRAND
								<el-popover placement="bottom" trigger="manual" v-model="popover.brand">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.brand" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.brand" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.brand.length ? '#606266' : '' }" @click="confirmFilters('brand')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('brand')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('brand')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="models" label="Model" key="models">
						<template #header>
							<div class="custom-header">
								Model
								<el-popover placement="bottom" trigger="manual" v-model="popover.models">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.models" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.models" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.models.length ? '#606266' : '' }" @click="confirmFilters('models')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('models')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('models')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="chassiscode" label="Chassis_Code" key="chassiscode" width="220">
						<template #header>
							<div class="custom-header">
								Chassis_Code
								<el-popover placement="bottom" trigger="manual" v-model="popover.chassiscode">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.chassiscode" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.chassiscode" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.chassiscode.length ? '#606266' : '' }" @click="confirmFilters('chassiscode')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('chassiscode')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('chassiscode')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="sop" label="Start_time" key="sop">
						<template #header>
							<div class="custom-header">
								Start_time

								<el-popover placement="bottom" trigger="manual" v-model="popover.sop">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.sop" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.sop" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.sop.length ? '#606266' : '' }" @click="confirmFilters('sop')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('sop')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('sop')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="eop" label="End_time" key="eop">
						<template #header>
							<div class="custom-header">
								End_time
								<el-popover placement="bottom" trigger="manual" v-model="popover.eop">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.eop" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.eop" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.eop.length ? '#606266' : '' }" @click="confirmFilters('eop')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('eop')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('eop')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="enginemodel" label="Engine" key="enginemodel">
						<template #header>
							<div class="custom-header">
								Engine
								<el-popover placement="bottom" trigger="manual" v-model="popover.enginemodel">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.enginemodel" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.enginemodel" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.enginemodel.length ? '#606266' : '' }" @click="confirmFilters('enginemodel')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('enginemodel')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('enginemodel')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
					<el-table-column align="center" prop="transmissiontype" label="Transmission" key="transmissiontype">
						<template #header>
							<div class="custom-header">
								Transmission
								<el-popover placement="bottom" trigger="manual" v-model="popover.transmissiontype">
									<div class="virtual-list">
										<el-checkbox-group v-model="select.transmissiontype" class="vertical-checkbox-group">
											<el-checkbox v-for="item in checkList.transmissiontype" :key="item.value" :label="item.value">
												{{ item.text }}
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="virtual-list-footer">
										<el-button type="text" :style="{ color: !select.transmissiontype.length ? '#606266' : '' }" @click="confirmFilters('transmissiontype')">Confirm</el-button>
										<el-button type="text" style="color: #606266" @click="resetFilters('transmissiontype')">Reset</el-button>
									</div>
									<template #reference>
										<i style="cursor: pointer" class="el-icon-arrow-down" @click="showPopover('transmissiontype')"></i>
									</template>
								</el-popover>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
import { aixinModelToGoods, aixinGoodsToCar, getOeInfo, getOeCar, cancelOeCarRequest, cancelOeInfoRequest } from "@/service/api/index.js";
import navbar from "@/components/navbar/index.vue";
import breadcrumb from "@/components/breadcrumb/index.vue";
import VirtualList from "vue-virtual-scroll-list";

export default {
	components: { navbar, breadcrumb, VirtualList },
	data() {
		return {
			loading: true,
			breadcrumbList: [],
			modelList: [],
			_tableData: [],
			tableData: [],
			activeIndex: 0,
			popover: {
				brand: false,
				models: false,
				chassiscode: false,
				sop: false,
				eop: false,
				enginemodel: false,
				transmissiontype: false,
			},
			select: {
				brand: [],
				models: [],
				chassiscode: [],
				sop: [],
				eop: [],
				enginemodel: [],
				transmissiontype: [],
			},
			checkList: {
				brand: [],
				models: [],
				chassiscode: [],
				sop: [],
				eop: [],
				enginemodel: [],
				transmissiontype: [],
			},
		};
	},

	mounted() {
		this.breadcrumbList = [{ name: this.$route.query.value.toLocaleUpperCase().replace(/-/g, ""), path: "" }];

		this.aixinModelToGoodsApi(this.$route.query.value);

		// setTimeout(() => {
		// 	if (this.loading) {
		// 		this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
		// 			confirmButtonText: "确定",
		// 			cancelButtonText: "取消",
		// 			type: "warning",
		// 		})
		// 			.then(() => {})
		// 			.catch(() => {});
		// 	}
		// }, 5000);
	},
	destroyed() {
		cancelOeCarRequest();
		cancelOeInfoRequest();
	},

	methods: {
		getCarousel() {
			for (let index = 0; index < this.modelList.length; index++) {
				const { goods_imgs } = this.modelList[index];
				if (goods_imgs && goods_imgs.length) {
					return goods_imgs; // 找到第一个符合条件的直接返回
				}
			}
			return []; // 如果没有找到符合条件的，返回空数组
		},
		handleIndicatorClick(index) {
			this.activeIndex = index;
			this.$refs.carousel.setActiveItem(index);
		},
		showPopover(key) {
			Object.keys(this.popover).forEach((item) => {
				if (item !== key) {
					this.popover[item] = false;
				}
			});
			this.popover[key] = !this.popover[key];
		},
		confirmFilters(key) {
			let filteredData = [...this._tableData];

			Object.keys(this.select).forEach((filterKey) => {
				const selectedValues = this.select[filterKey];
				if (selectedValues && selectedValues.length) {
					filteredData = filteredData.filter((item) => selectedValues.includes(item[filterKey]));
				}
			});

			// 更新 tableData 为筛选后的数据
			this.tableData = filteredData;

			// 关闭 popover
			this.popover[key] = false;
		},
		resetFilters(key) {
			// 清空当前筛选项
			this.select[key] = [];
			this.popover[key] = false;
			// 使用 _tableData 作为数据的起点
			let tempData = [...this._tableData];

			// 遍历其他筛选条件，应用筛选
			Object.keys(this.select).forEach((filterKey) => {
				const selectedValues = this.select[filterKey];
				if (selectedValues && selectedValues.length) {
					tempData = tempData.filter((item) => selectedValues.includes(item[filterKey]));
				}
			});

			// 最后更新 tableData
			this.tableData = tempData;
		},
		// 获取产品
		async aixinModelToGoodsApi(model) {
			const { datas } = await aixinModelToGoods(model);

			let _datas = JSON.parse(JSON.stringify(datas));
			this.modelList = _datas.map((element, index) => {
				if (element.oes && element.oes.length) {
					const chunkedArray = [];
					for (let i = 0; i < element.oes.length; i += 5) {
						chunkedArray.push(element.oes.slice(i, i + 5));
					}
					element.oes = chunkedArray;
				}

				return element;
			});

			// console.log("this.modelList", this.modelList);

			const carResults = await Promise.all(
				datas.map(async (element, index) => {
					const oeInfoList = await Promise.all(
						element.oes.map(async (item) => {
							return await this.getOeInfoApi(item);
						})
					);

					// 过滤掉空数组
					const filteredOeInfoList = oeInfoList.filter((item) => item.length > 0);

					const oeCarResults = await Promise.all(
						filteredOeInfoList.map(async (item) => {
							return await Promise.all(item.map((ii) => this.getOeCarApi(ii)));
						})
					);

					return oeCarResults.flat().flat();
				})
			);

			const mergedTableData = carResults.flat();

			// 使用 Map 去重
			const uniqueTableData = Array.from(new Map(mergedTableData.map((item) => [item.hw_id, item])).values());

			const sortData = this.$tools.sortCharAt(uniqueTableData, "brand");

			sortData.map((item) => {
				for (const key in this.checkList) {
					// 使用 push 将数据添加到 select[key] 中
					this.checkList[key].push({
						text: item[key],
						value: item[key],
					});
				}
			});

			// 去重操作，只执行一次
			for (const key in this.checkList) {
				this.checkList[key] = Array.from(new Map(this.checkList[key].map((obj) => [obj.value, obj])).values());
			}

			// console.log("carResults", sortData);

			this.tableData = sortData;
			this._tableData = sortData;

			this.loading = false;
		},
		// 获取适配车型
		async aixinGoodsToCarApi(goods_id) {
			const { datas } = await aixinGoodsToCar(goods_id);
			return datas ? datas : [];
		},
		async getOeInfoApi(oe) {
			const { datas } = await getOeInfo({ oe });
			return datas ? datas.items : [];
		},
		// 获取车型信息
		async getOeCarApi({ oe, brand_code }) {
			const { datas } = await getOeCar({ oe, brand_code });

			if (!datas) return [];

			return datas.items;
		},
	},
};
</script>

<style lang="less" scoped>
.virtual-list {
	max-height: 300px;
	overflow-y: auto;
}
.vertical-checkbox-group {
	display: flex;
	flex-direction: column;
}

.page {
	background: #f8f9fb;
	width: 100%;
	padding-bottom: 30px;
	min-height: calc(100vh - 30px - 220px);
}
.content {
	width: 1350px;
	margin: 0 auto;
	border: 1px solid #e6e6e6;
	background: #fff;
	margin-top: 15px;
	padding: 25px;
}
.mess {
	align-items: flex-start;
}
.indicator-active {
	border: 1px solid @theme-color !important;
}
.swiper {
	width: 300px;
	.el-carousel {
		border: 1px solid #e6e6e6;
	}
	.indicator {
		display: flex;
		align-items: center;
		margin-top: 10px;
		.indicator-item {
			width: 50px;
			height: 50px;
			border: 1px solid #e6e6e6;
			margin-right: 5px;
			cursor: pointer;
			&:last-child {
				margin-right: 0;
			}
			img {
				width: 100%;
				height: 100%;
				object-fit: contain;
			}
		}
	}
}
.info {
	flex: 1;
	align-items: flex-start;
	margin-left: 20px;

	.title {
		font-size: 26px;
		font-weight: 550;
		margin-bottom: 20px;
	}
	.subtitle {
		font-size: 20px;
		font-weight: normal;
		word-break: break-all;
		align-items: flex-start;
		margin-top: 10px;
		.label {
			width: 140px;
		}
		.value {
			flex: 1;
		}
	}
}
.spec {
	width: 100%;
	border: 1px solid #e6e6e6;
	margin-top: 10px;
	.name {
		background-color: #f9f9f9;
		color: @theme-color;
		font-size: 15px;
		padding: 5px 10px;
		font-weight: 550;
		border-bottom: 1px solid #e6e6e6;
	}
	.spec-list {
		padding: 0 10px 10px 10px;
		.spec-item {
			margin-top: 10px;
			font-size: 14px;
			color: #666;
		}
	}
}
.table {
	width: 100%;
	border-bottom: 1px solid #e6e6e6;
	border-right: 1px solid #e6e6e6;
	border-left: 1px solid #e6e6e6;
	&:nth-child(2) {
		border-top: 1px solid #e6e6e6;
	}
	.table-item {
		width: 50%;
		min-height: 35px;
		.table-item-name {
			background-color: #f5f9fc;
			width: 50%;
			text-align: center;
			height: 100%;
			border-right: 1px solid #e6e6e6;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.table-item-value {
			width: 50%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-wrap: wrap;
		}
	}
}
</style>
